import React from "react";

const CheckboxInput = ({ label, id, register, errors, onKeyDown, className }) => {
	return (
		<div className={`flex items-center ${className}`}>
			<div className="flex gap-2">
				<input
					className={errors[id] ? "error" : ""}
					id={id}
					type="checkbox"
					{...register(id)}
					onKeyDown={onKeyDown}
					autoComplete="off"
				/>
				<label htmlFor={id}>
					<span className="text-sm">{label}</span>
				</label>
			</div>
		</div>
	);
};

export default CheckboxInput;
